import type React from "react"
import Header from "../components/organisms/Header"
import HeroSection from "../components/organisms/HeroSection"
import HowItWorksSection from "../components/organisms/HowItWorksSection"
import WhyChooseUsSection from "../components/organisms/WhyChooseUsSection"
import TestimonialsSection from "../components/organisms/TestimonialsSection"
import ContactSection from "../components/organisms/ContactSection"
import AppDownloadSection from "../components/organisms/AppDownloadSection"
import Footer from "../components/organisms/Footer"

const HomePage: React.FC = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <WhyChooseUsSection />
        <TestimonialsSection />
        <AppDownloadSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  )
}

export default HomePage
